const normalizeOrigin = (value, fallback) => (value || fallback).replace(/\/$/, '');

export const APP_ORIGIN = normalizeOrigin(
  process.env.REACT_APP_APP_URL,
  typeof window !== 'undefined' ? window.location.origin : 'https://app.bidsignaliq.com',
);

export const appUrl = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${APP_ORIGIN}${normalizedPath}`;
};

export const openApp = (path = '/') => {
  if (typeof window !== 'undefined') window.location.assign(appUrl(path));
};
